import { PageHero, Reveal } from "../components/common";
import { ORG } from "../data/site";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you use our contact or donation pledge forms, we collect the details you provide: your name, email address, phone number, postal address, PAN (optional, for donation records) and the content of your message. We also collect anonymous usage statistics to understand how the website is used.",
  },
  {
    title: "How we use it",
    body: "Your details are used solely to respond to your enquiry, to contact you about completing a donation pledge, and to maintain the records the Trust is required to keep under Indian law. We do not send marketing emails and we do not add you to any mailing list.",
  },
  {
    title: "What we never do",
    body: "We never sell, rent or share your personal information with third parties for marketing purposes. Your information is not published anywhere on this website.",
  },
  {
    title: "Storage and security",
    body: "Form submissions are stored securely and are accessible only to the Trust's trustees. This website currently takes no online payments, so no card or banking details are ever collected here.",
  },
  {
    title: "Your rights",
    body: "You may ask us at any time to correct or delete the personal information we hold about you. Simply email or call us using the details below and we will act on your request promptly.",
  },
];

export default function Privacy() {
  return (
    <>
      <PageHero
        overline="Legal"
        title="Privacy Policy"
        copy="Susanna Charitable Trust respects your privacy. This policy explains, in plain language, what we collect and why."
      />
      <section className="pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div className="border-t border-charcoal/15 pt-6">
                <h2 className="font-serif text-2xl font-medium tracking-tight">{s.title}</h2>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-charcoal/70">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.1}>
            <div className="bg-softgray rounded-2xl p-8">
              <h2 className="font-serif text-2xl font-medium tracking-tight">Contact us about privacy</h2>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-charcoal/70">
                {ORG.name} · {ORG.address}
                <br />
                Email: {ORG.email} · Phone: {ORG.phone}
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
